import { Injectable, inject, signal } from '@angular/core';
import { IDevice, IPatient } from '../interfaces';
import { createEffect } from './create-effect';
import { EUserRole, IUser } from 'src/app/core';

const EMPTY_USER: IUser = {
  id: '',
  email: '',
  fullName: '',
  phoneNumber: '',
  imagePath: '',
  role: EUserRole.DOCTOR,
};

@Injectable({ providedIn: 'root' })
export class AppStore {
  private readonly state = {
    $loadingPatients: signal<boolean>(false),
    $loadingDevices: signal<boolean>(false),
    $language: signal<string>('en'),
    $user: signal<IUser>(EMPTY_USER),
    $pageLoading: signal<boolean>(false),
  } as const;

  readonly $loadingPatients = this.state.$loadingPatients.asReadonly();
  readonly $loadingDevices = this.state.$loadingDevices.asReadonly();
  readonly $language = this.state.$language.asReadonly();
  readonly $user = this.state.$user.asReadonly();
  readonly $pageLoading = this.state.$pageLoading.asReadonly();

  setLanguage(language: string): void {
    this.state.$language.set(language);
  }

  setUser(user: IUser): void {
    this.state.$user.set(user);
  }

  setPageLoading(loading: boolean): void {
    this.state.$pageLoading.set(loading);
  }
}
